import { render } from "./PatientInfoHeader.vue?vue&type=template&id=09479631&scoped=true&ts=true"
import script from "./PatientInfoHeader.vue?vue&type=script&lang=ts"
export * from "./PatientInfoHeader.vue?vue&type=script&lang=ts"

import "./PatientInfoHeader.vue?vue&type=style&index=0&id=09479631&lang=scss&scoped=true"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09479631"]])

export default __exports__